<template>
  <div>
    <!-- <v-row class="text-left search-bar">
      <v-col cols="4" class="pl-6">
        <v-btn class="ma-0 pa-0 pt-1" outlined style="border:none; height:40px; width:100%;" @click="memberSearchStatus = !memberSearchStatus">
          <v-text-field readonly outlined placeholder="專案認證考試資訊查詢" class="keyword text_field"
          dense v-model="select" background-color="white" style="margin-top:4px">
            <template v-slot:append>
              <v-icon class="ml-1" color="white" style="background:#215DA7">mdi-chevron-down</v-icon>
            </template>
          </v-text-field>
        </v-btn>
        <v-list v-if="memberSearchStatus" class="py-4" style="position: absolute; z-index: 100; border-radius: 8px;">
          <v-list-item style="width:500px; cursor:pointer">
            <div class="text-right pt14" style="width:80px">認證考區</div>
            <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇"
            :items="TITLE_LIST" item-text="title" item-value="title"></v-select>
          </v-list-item>
          <v-list-item style="width:500px; cursor:pointer">
            <div class="text-right pt14" style="width:80px">認證考場</div>
            <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇"
            :items="TITLE_LIST" item-text="title" item-value="title"></v-select>
          </v-list-item>
          <v-list-item style="width:500px; cursor:pointer">
            <div class="text-right pt14" style="width:80px">認證項目</div>
            <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇"
            :items="TITLE_LIST" item-text="title" item-value="title"></v-select>
          </v-list-item>
          <v-list-item style="width:500px; cursor:pointer">
            <div class="text-right pt14" style="width:80px">認證模組</div>
            <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇"
            :items="TITLE_LIST" item-text="title" item-value="title"></v-select>
          </v-list-item>
          <v-list-item style="width:500px; cursor:pointer">
            <div class="text-right pt14" style="width:80px">認證廠商</div>
            <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇"
            :items="TITLE_LIST" item-text="title" item-value="title"></v-select>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="3">
        <v-text-field outlined placeholder="關鍵字及場次代碼查詢" class="keyword text_field"
        dense v-model="keyword" background-color="white" style="margin-top:4px">
          <template v-slot:append>
            <v-icon class="ml-1" color="white" style="background:#215DA7" @click="search">icon-form_search</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="5" class="py-4">
        <v-row>
          <h4 class="pt-2 mx-2 pt14" style="font-weight:400">認證日期</h4>
          <div class="mx-2" style="width:38%">
            <v-menu ref="menuS" v-model="menuS" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined background-color="white" readonly class="text_field" placeholder="開始日期"
                  v-model="startDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="startDate" no-title scrollable></v-date-picker>
            </v-menu>
          </div>
          <div class="mx-1" style="width:40%">
            <v-menu ref="menuE" v-model="menuE" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined background-color="white" readonly class="text_field" placeholder="結束日期"
                  v-model="endDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="endDate" no-title scrollable></v-date-picker>
            </v-menu>
          </div>
        </v-row>
      </v-col>
    </v-row> -->
    <v-row id="router" class="ma-0 pa-0" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th @click="sort('examNo')" class="text-center">場次代碼<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('payStatus')">繳費狀態<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examDate')">認證日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('frontendArea')">認證考區<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examCompany')">認證考場<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class1')">認證項目<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class2')">認證模組<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class3')">認證廠商<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('payGroup')">繳費方式<v-icon small>icon-form_sort_off</v-icon></th>
                <th class="text-center" @click="sort('applyStatus')">場次狀態<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examScore')">成績<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index">
                <td class="pt-2 pb-1" style="min-width: 130px">
                  <v-btn outlined style="height:28px; background:#215DA7; color:#FFF" @click="redirectPath('/registerInformation',data.id),0"><span style="font-size:14px">詳細資訊</span></v-btn>
                  <h4 class="ml-3" style="font-size:14px; font-weight:400;">{{data.examNo}}</h4>
                </td>
                <td class="text-center" style="min-width: 110px">
                  <h4 v-show="data.payStatus == '5' && data.payGroup=='1'">{{$Global.getTypevDescription(payStatusList,data.payStatus)}}</h4>
                  <v-btn v-show="data.payStatus == '5' && data.payGroup=='2'" outlined style="height:28px; background:#FF5656; color:#FFF; width:80px" @click="redirectPath('/registerInformation',data.id,1)"><span style="font-size:14px">前往繳費</span></v-btn>
                  <h4 v-show="data.payStatus != '5'">{{$Global.getTypevDescription(payStatusList,data.payStatus)}}</h4>
                </td>
                <td style="min-width: 110px"><h4>{{data.examDate}}</h4><h4>{{data.examTime}}</h4></td>
                <td style="min-width: 110px"><h4>{{$Global.getTypevDescription(frontendAreaList,data.frontendArea)}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.examCompany}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class1}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class2}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class3}}</h4></td>
                <td style="min-width: 110px"><h4>{{(data.payGroup=='1') ? '團體繳費': (data.payGroup=='2') ? '個人繳費': ''}}</h4></td>
                <td style="min-width: 110px">
                  <h4 :style = "[{'color' : (data.applyStatus==1) ? '#444' : (data.applyStatus==2) ? '#215DA7' : (data.applyStatus==3) ? '#444' : (data.applyStatus==4) ? '#F00' : '#F00'}]">
                    {{$Global.getTypevDescription(applyStatusList,data.applyStatus)}}</h4>
                </td>
                <td style="min-width: 100px">
                  <h4>{{(data.examScore) ? data.examScore : ''}}</h4>
                  <h4>({{(data.examPass) ? data.examPass : '未公布'}})</h4>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="px-5 py-0">
        <v-col class="col-0 col-sm-0 col-md-2 col-lg-7 pagination-max pl-5 mt-3 text-right pr-8">共 {{pagination.totalCount}} 筆</v-col>
        <v-col class="col-12 col-sm-8 col-md-6 col-lg-3 pr-0">
          <v-pagination color="#81C0E2" v-model="pagination.page" :length="pagination.totalPage"
          :total-visible="5"></v-pagination>
        </v-col>
        <v-col class="col-12 col-sm-4 col-md-4 col-lg-2">
          <v-row class="row">
            <v-col class="col-5 col-sm-4 pt-3 text-right">前往</v-col>
            <v-col class="col-2 col-sm-4 pa-0">
            <v-text-field outlined dense v-model="destPage" @keyup.enter="setDestPage()"></v-text-field>
            </v-col>
            <v-col class="col-5 col-sm-4 pt-3 text-left">頁</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>


export default {
  name: 'RegisterInformationList',
  components: {},
  mounted(){
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getPayStatusList().then(res=>{ this.payStatusList = res })
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.getDataset()
  },
  data:() => ({
    select:'',
    keyword:'',
    datasets: [],
    pagination:{page:1,totalPage:10,totalCount:10},
    orderBy:'examDate',
    direction:'desc',
    destPage:'',
    showRange:false,
    dates: ['2021-07-05', '2021-07-20'],
    viewStyle:{},
    memberSearchStatus: false,
    startDate:'',
    endDate:'',
    menuS:'',
    menuE:'',
    frontendAreaList: [],
    payStatusList: [],
    applyStatusList: [],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "pagination.page":function(){
      this.getDataset()
    }
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' - ')
    },
  },
  methods:{
    calculateWindows(){
    this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path, id, tab){
      this.$router.push({path: path, query: {
        id: this.$Global.encrypt(JSON.stringify(id)),
        tab: tab,
      }})
    },
    setDestPage(){
      this.pagination.page = parseInt(this.destPage)
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegListByIdCard',
        params: {
          'idCard':sessionStorage.getItem('cerpsMemberIdCard'),
          'page':self.pagination.page,
          'limit':10,
          'order': self.orderBy,
          'direction': self.direction,
          'source': '',
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data.data
        self.pagination.totalCount = response.data.data.total
        self.pagination.totalPage = response.data.data.page
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Ril-7956')
      })
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .pagination-max {
      display: none !important;
    }
  }
</style>